import { Pipe, PipeTransform } from '@angular/core';
import { ContractPaymentFrequency } from '../../interfaces/contract';

@Pipe({
  name: 'contractPaymentFrequency'
})
export class ContractPaymentFrequencyPipe implements PipeTransform {

  transform(value: ContractPaymentFrequency): string {
    const type = {
      [ContractPaymentFrequency.WEEKLY]: 'Semanal',
      [ContractPaymentFrequency.FORTWEEKLY]: 'Quinzenal',
      [ContractPaymentFrequency.MONTHLY]: 'Mensal',
      [ContractPaymentFrequency.YEARLY]: 'Anual'
    }

    return type[value]
  }

}
